/* Copyright 2021, Milkdown by Mirone. */
import { themeToolCtx } from '@milkdown/core';
import { themeMustInstalled } from '@milkdown/exception';
export const getClassName = (className) => (attrs, ...defaultValue) => {
    var _a;
    const classList = (_a = className === null || className === void 0 ? void 0 : className(attrs)) !== null && _a !== void 0 ? _a : defaultValue;
    return Array.isArray(classList) ? classList.filter((x) => x).join(' ') : classList;
};
export const commonPlugin = (factory, ctx, options) => {
    try {
        const themeTool = ctx.get(themeToolCtx);
        const utils = {
            ctx,
            getClassName: getClassName(options === null || options === void 0 ? void 0 : options.className),
            getStyle: (style) => ((options === null || options === void 0 ? void 0 : options.headless) ? '' : style(themeTool)),
        };
        return factory(options, utils);
    }
    catch (_a) {
        throw themeMustInstalled();
    }
};
//# sourceMappingURL=base-common.js.map